<template>
  <div>
    <div v-if="!loading">
      <v-select v-model="selectedValue" :items="items"></v-select>
    </div>
    <p v-else>Loading</p>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      items: [],
      loading: true,
      addActive: false
    };
  },
  props: {
    value: {
      type: String
    },
    label: {
      type: String
    }
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  mounted() {
    this.getTypes();
  },

  watch: {
    value: function() {
      this.$emit("input", this.value);
    }
  },
  methods: {
    async getTypes() {
      await axios
        .get("service-block-type")
        .then(
          function(response) {
            if (response.status === 200) {
              this.items = response.data;
              this.loading = false;
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
          }.bind(this)
        );
    }
  }
};
</script>